import DocumentTemplate from '@/models/DocumentTemplate';

const GET_DOCUMENT_TEMPLATE = 'get_document_template';
const GET_DOCUMENT_TEMPLATE_REQUEST = 'get_document_template_request';
const GET_DOCUMENT_TEMPLATE_SUCCESS = 'get_document_template_success';
const GET_DOCUMENT_TEMPLATE_ERROR = 'get_document_template_error';

const SAVE_DOCUMENT_TEMPLATE = 'save_document_template';
const SAVE_DOCUMENT_TEMPLATE_REQUEST = 'save_document_template_request';
const SAVE_DOCUMENT_TEMPLATE_SUCCESS = 'save_document_template_success';
const SAVE_DOCUMENT_TEMPLATE_ERROR = 'save_document_template_error';

const NEW_DOCUMENT_TEMPLATE = 'new_document_template';

export {
    GET_DOCUMENT_TEMPLATE,
    SAVE_DOCUMENT_TEMPLATE,
    NEW_DOCUMENT_TEMPLATE,
};

export default {
    state: {
        template: {
            name: '',
            contents: '',
            fields: [],
            requires_approval: true,
        },
        loading: false,
        templateErrors: [],
    },
    mutations: {
        [GET_DOCUMENT_TEMPLATE_REQUEST]: (state) => {
            state.template = {};
            state.loading = true;
            state.templateErrors = [];
        },
        [GET_DOCUMENT_TEMPLATE_SUCCESS]: (state, {template}) => {
            state.template = template;
            state.loading = false;
            state.templateErrors = [];
        },
        [GET_DOCUMENT_TEMPLATE_ERROR]: (state, {errors}) => {
            state.template = {
                name: '',
                contents: '',
                fields: []
            };
            state.loading = false;
            state.templateErrors = errors;
        },
        [SAVE_DOCUMENT_TEMPLATE_REQUEST]: (state) => {
            state.loading = true;
            state.templateErrors = [];
        },
        [SAVE_DOCUMENT_TEMPLATE_SUCCESS]: (state, {template}) => {
            state.template = template;
            state.loading = false;
            state.templateErrors = [];
        },
        [SAVE_DOCUMENT_TEMPLATE_ERROR]: (state, {errors}) => {
            state.template = {
                name: '',
                contents: '',
                fields: []
            };
            state.loading = false;
            state.templateErrors = errors;
        },
    },
    actions: {
        [GET_DOCUMENT_TEMPLATE]: ({commit, state}, {id = state.template.id}) => {
            commit(GET_DOCUMENT_TEMPLATE_REQUEST);
            return new Promise((resolve, reject) => {
                DocumentTemplate.document(id)
                    .then(template => {
                        commit(GET_DOCUMENT_TEMPLATE_SUCCESS, {template});
                        resolve(template);
                    })
                    .catch(({status, errors}) => {
                        commit(GET_DOCUMENT_TEMPLATE_ERROR, {errors});
                        reject(({status, errors}));
                    });
            });
        },
        [SAVE_DOCUMENT_TEMPLATE]: ({commit, state}, {template = state.template}) => {
            commit(SAVE_DOCUMENT_TEMPLATE_REQUEST);
            return new Promise((resolve, reject) => {
                template.save()
                    .then(template => {
                        commit(SAVE_DOCUMENT_TEMPLATE_SUCCESS, {template});
                        resolve(template);
                    })
                    .catch(({status, errors}) => {
                        commit(SAVE_DOCUMENT_TEMPLATE_ERROR, {errors});
                        reject(({status, errors}));
                    });
            });
        },
        [NEW_DOCUMENT_TEMPLATE]: ({commit, state}, {template = new DocumentTemplate()}) => {
            commit(GET_DOCUMENT_TEMPLATE_SUCCESS, {template});
            return template;
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/document-template.js